module.exports = __webpack_public_path__ + "static/img/M2-S-117-1.8db5985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/module1-2/M2-S-117-1.png
// module id = 450
// module chunks = 0